import { useContext } from 'react';
import Echo from '@ably/laravel-echo';

import { Nullable } from '../../../../types';
import { WebsocketContext } from '../../WebsocketContext';

/**
 * Returns the active Echo connection, or null before one is established.
 *
 * Escape hatch for advanced channel usage that the event-subscription hooks do
 * not model (e.g. the workbook presence channel, which needs
 * here/joining/leaving/whisper). Prefer the subscribe hooks for plain events.
 */
export const useWebsocketConnection = (): Nullable<Echo> => {
  const { connection } = useContext(WebsocketContext);
  return connection;
};
